import axios from "@axios";

export default {
  getProviders() {
    return axios.get("/llpr/providers");
  },
  getModels() {
    return axios.get("/llpr/models");
  },
  getEnvKeys(providerId) {
    return axios.get("/llpr/env-keys", { params: { provider_id: providerId } });
  },
  createModel(data) {
    return axios.post("/llpr/models", data);
  },
  updateModel(id, data) {
    return axios.put(`/llpr/models/${id}`, data);
  },
  deleteModel(id) {
    return axios.delete(`/llpr/models/${id}`);
  },
  getContexts() {
    return axios.get("/llpr/contexts");
  },
  createContext(data) {
    return axios.post("/llpr/contexts", data);
  },
  updateContext(code, data) {
    return axios.put(`/llpr/contexts/${code}`, data);
  },
  deleteContext(code) {
    return axios.delete(`/llpr/contexts/${code}`);
  },
  getContextSteps(code) {
    return axios.get(`/llpr/contexts/${code}/steps`);
  },
  createContextStep(code, data) {
    return axios.post(`/llpr/contexts/${code}/steps`, data);
  },
  updateContextStep(stepId, data) {
    return axios.put(`/llpr/steps/${stepId}`, data);
  },
  deleteContextStep(stepId) {
    return axios.delete(`/llpr/steps/${stepId}`);
  },
  reorderContextSteps(code, stepIds) {
    return axios.post(`/llpr/contexts/${code}/steps/reorder`, stepIds);
  },
  getTemplates() {
    return axios.get("/llpr/templates");
  },
  createTemplate(data) {
    return axios.post("/llpr/templates", data);
  },
  updateTemplate(id, data) {
    return axios.put(`/llpr/templates/${id}`, data);
  },
  deleteTemplate(id) {
    return axios.delete(`/llpr/templates/${id}`);
  },
  getTemplateDetail(id) {
    return axios.get(`/llpr/templates/${id}`);
  },
  getRevisions(templateId) {
    return axios.get(`/llpr/templates/${templateId}/revisions`);
  },
  createRevision(templateId, data) {
    return axios.post(`/llpr/templates/${templateId}/revisions`, data);
  },
  updateRevision(revisionId, data) {
    return axios.put(`/llpr/revisions/${revisionId}`, data);
  },
  activateRevision(templateId, revisionId) {
    return axios.post(`/llpr/templates/${templateId}/activate/${revisionId}`);
  },
  getBindings(contextCode = null, siteId = null) {
    const params = {};
    if (contextCode) params.context_code = contextCode;
    if (siteId) params.site_id = siteId;
    return axios.get("/llpr/bindings", { params });
  },
  createBinding(data) {
    return axios.post("/llpr/bindings", data);
  },
  updateBinding(id, data) {
    return axios.put(`/llpr/bindings/${id}`, data);
  },
  deleteBinding(id) {
    return axios.delete(`/llpr/bindings/${id}`);
  },
  resolvePrompt(data) {
    return axios.post("/llpr/resolve", data);
  },

  // --- LOGGING ---
  getLogs(params = {}) {
    return axios.get("/llpr/logs", { params });
  },
  getLogDetail(id) {
    return axios.get(`/llpr/logs/${id}`);
  },
  toggleTemplateLogging(id, enabled) {
    return axios.patch(`/llpr/templates/${id}/logging`, null, { params: { enabled } });
  },
};
